import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const CitasDespues = () => {
  const [citas, setCitas] = useState([]);
  const [notas, setNotas] = useState({});
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchCitas = async () => {
      try {
        const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/obtenercitasdespues", {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        if (data && data) {
          setCitas(data);
        } else {
          console.error("No se puede oiga");
        }
      } catch (error) {
        console.error("Error al obtener las citas [N1]");
      }
    };
    fetchCitas();
  }, [token]);

  const handleNotaChange = (id, texto) => {
    setNotas((prevNotas) => ({
      ...prevNotas,
      [id]: texto,
    }));
  };

  const handleGuardar = async (id) => {
    const nota = notas[id] || "";
    console.log(`Guardar nota para ID ${id}:`, nota);
    try {
      const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/actualizarnotacitas", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          nota: nota,
        }),
      });

      if (response.ok) {
        Swal.fire({
              title: "Anotacion guardada",
              icon: "success",
              draggable: true
            });
      } else {
        Swal.fire({
              title: "No se pudo guardar la anotacion.",
              icon: "error",
              draggable: true
            });
      }
    } catch (error) {
      console.error("Error al enviar los datos [N2]");
      alert("Error en la conexión");
    }
  };


  const handleEliminar = async (id) => {
    const resultado = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción eliminará la cita permanentemente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#c53030",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (resultado.isConfirmed) {
      try {
        const response = await fetch("https://ricardodiaztuasesorfinanciero.com/api/EliminarCita", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id }),
        });

        const result = await response.json();

        if (response.ok) {
          Swal.fire("Eliminada", "La cita fue eliminada correctamente.", "success");
          setCitas(citas.filter((cita) => cita.id !== id));
        } else {
          Swal.fire("Error", "No se pudo eliminar la cita. [N3]", "error");
        }
      } catch (error) {
        console.error("Error al eliminar la cita [N4]");
        Swal.fire("Error", "Ocurrió un error en la conexión. [N5]", "error");
      }
    }
  };

  return (
    <div style={styles.contenedor}>
      <div style={styles.cabecera}>
        <h2 style={styles.tituloCabecera}>📋 Panel de administración de citas</h2>
        <div style={styles.botonera}>
          <button style={styles.botonRegresar} onClick={() => navigate('/')}>🏠 Menú Principal</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/CitasClientes')}>📆 Citas Pendientes</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/citasdespues')}>👥 Citas Finalizadas</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/adminseguros')}>📃 Formularios</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/horariosadmin')}>🕒 Horarios</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/adminblog')}>📰 Blog</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/aiuda')}>⚙️ Ayuda</button>
        </div>
      </div>

      <div style={styles.grid}>
        {citas.map((cita) => (
          <div key={cita.id} style={styles.card}>
            <div style={styles.infoGrid}>
              <div style={styles.seccion}>
                <h4 style={styles.subtitulo}>👤 Datos del cliente</h4>
                <p><strong>Nombre:</strong> {cita.Nombre}</p>
                <p><strong>Correo:</strong> {cita.Correo}</p>
                <p><strong>Teléfono:</strong> {cita.Numero}</p>
                <p><strong>Fecha:</strong> {cita.Fecha}</p>
              </div>
            </div>

            <label htmlFor={`nota-${cita.id}`} style={styles.label}>Nota:</label>
            <textarea
              id={`nota-${cita.id}`}
              style={styles.textarea}
              placeholder="Escribe una nota relacionada con esta persona..."
              value={notas[cita.id] !== undefined ? notas[cita.id] : (cita.nota || "")}
              onChange={(e) => handleNotaChange(cita.id, e.target.value)}
            />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
            <button style={styles.btnGuardar} onClick={() => handleGuardar(cita.id)}>💾 Guardar</button>
            <button style={styles.btnEliminar} onClick={() => handleEliminar(cita.id)}>🗑️ Eliminar</button>
          </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  contenedor: {
    padding: "50px 40px",
    fontFamily: "Segoe UI, sans-serif",
    backgroundColor: "#eef2f7",
    minHeight: "100vh",
  },
  cabecera: {
    backgroundColor: '#102a43',
    color: 'white',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tituloCabecera: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  botonRegresar: {
    backgroundColor: '#334e68',
    border: 'none',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    marginLeft: '10px',
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))",
    gap: "30px",
  },
  card: {
    backgroundColor: "#334e68",
    color: "white",
    padding: "25px",
    borderRadius: "16px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    marginBottom: "15px",
  },
  seccion: {
    marginBottom: "15px",
  },
  subtitulo: {
    fontSize: "16px",
    marginBottom: "8px",
    borderBottom: "1px solid white",
    paddingBottom: "4px",
    fontWeight: "bold",
  },
  label: {
    marginTop: "5px",
    marginBottom: "10px",
    fontWeight: "600",
    color: "white",
    display: "block",
    fontSize: "16px",
  },
  textarea: {
    padding: "10px",
    borderRadius: "8px",
    fontSize: "14px",
    border: "none",
    resize: "none",
    height: "80px",
    backgroundColor: "#f7fafc",
    color: "#1a202c",
  },
btnGuardar: {
  marginTop: "10px",
  backgroundColor: "#2f855a",
  color: "white",
  border: "none",
  padding: "10px",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: "bold",
  alignSelf: "flex-start",
},

  btnEliminar: {
    marginTop: "10px",
    backgroundColor: "#c53030",
    color: "white",
    border: "none",
    padding: "10px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    alignSelf: "flex-end",
  },
  botonera: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '15px',
  },
};

export default CitasDespues;
